import React from 'react';

import { countries } from '../../constants';
import { connectDetailComponent } from '../DetailsPopover.container';
import Details from './Details';

// Let the labels and values grow and shrink as needed. They will all be
// rendered in one row anyway.
const colDistribution = ['auto', 'auto'];

function QuoteLineDetailRow(props) {
  return (
    <tr>
      {/* Checkbox and button columns */}
      <td colSpan={2} />
      <td
        colSpan={
          4 /* Label columns */ +
          7 /* Budget columns */ +
          (1 + countries.length) /* Country split columns */
        }
      >
        <Details {...props} colDistribution={colDistribution} withPortal />
      </td>
    </tr>
  );
}

QuoteLineDetailRow.propTypes = {};

export default connectDetailComponent(QuoteLineDetailRow);
